module.exports = __webpack_public_path__ + "img/2.a64bc4f8.png";